import React from 'react';
import { pureRender } from 'epic-alt-utils';
import map from 'lodash/map';
import autobind from 'core-decorators/lib/autobind';
import { NavActions } from '../../actions';
import { getDataAttribute } from '../../utils/compatibilityUtils';
import './styles/sitenav-kids.sass';

@pureRender
export default class SiteNavKids extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            close: false,
            kidIndexHover: null
        };
    }

    @autobind
    clickKidLink(e) {
        const index = getDataAttribute(e.currentTarget, 'index');
        const kid = this.props.kids[index];
        if (kid && kid.onClick && typeof kid.onClick === 'function') {
            kid.onClick(e);
        }

        NavActions.closeMobileTablet.defer();
        e.stopPropagation(); //dont head up to the parent click event
    }

    @autobind
    back(e) {
        e.preventDefault();
        NavActions.mobileActiveLinkIndex(null);
    }

    showGrandKid() {
        if (typeof this.props.parentIndex === 'number') {
            const parentId = `sitenav-link-${this.props.parentIndex}`;
            let element = document.getElementById(parentId);
            if (!element) {
                element = document.getElementById(`${parentId}-collapseParent`);
            }
            if (element) {
                const classList = element.getElementsByClassName('site-nav-kids-desktop')[0].classList;
                if (!classList.contains('show-grandkid')) {
                    classList.add('show-grandkid');
                }
            }
        }
    }

    @autobind
    kidHover(e) {
        const grandKidsLength = getDataAttribute(e.currentTarget, 'gkl');
        if (!grandKidsLength || grandKidsLength < 1) {
            return;
        }
        this.showGrandKid();
    }

    @autobind
    kidMouseLeave(e) {
        const grandKidsLength = getDataAttribute(e.currentTarget, 'gkl');
        if (!grandKidsLength || grandKidsLength < 1) {
            return;
        }
        this.showGrandKid();
    }

    render() {
        //check to make sure instance of seamless immutable
        let kidArray = [];
        if (this.props.kids && this.props.kids.asMutable) {
            kidArray = this.props.kids.asMutable();
        } else {
            if (process.env.NODE_ENV !== 'production') {
                console.warn('[EGH] SiteNavKids Expects a seamless immutable array!!');
            }
        }

        const isMobile = this.props.isMobile || false;
        const isTablet = this.props.isTablet || false;
        const active = this.props.active ? 'active bg-color' : '';
        let grandKids;

        if (isMobile || isTablet) {
            return (
                <ul className={`siteNavKids ${isMobile ? 'mobile' : ''} ${isTablet ? 'tablet' : ''} ${active}`}>
                    <li className="mobile-heading" onClick={this.back}>
                        <a><span className="text-color-mobile-heading">{this.props.parentLink.title}</span></a>
                    </li>
                {
                    map(kidArray, (link, i) => {
                        if (link.title) {
                            return (
                                <li
                                    className="mobile-list-item"
                                    key={`sitenav-link-${link.title}`}
                                    data-index={i}
                                    onClick={this.clickKidLink}>
                                    <a
                                        className={`text-color-hover ${this.props.activeChild !== null && this.props.activeChild === i ?
                                            'active text-color-active' : 'text-color-nonactive'}`}
                                        href={link.href || '#'}
                                        target={link.target}>
                                        <span>{link.title}</span>
                                    </a>
                                </li>
                            );
                        }

                        if (process.env.NODE_ENV !== 'production') {
                            console.warn('Site Link was not passed a title!');
                        }
                        return undefined;
                    })
                }

                </ul>
            );
        }

        return (
            <ul className={'kids site-nav-kids-desktop'}>
                {
                    map(kidArray, (kid, i) => {
                        if (kid.hasKids && kid.isCollapsed && kid.kids) {
                            const grandKidArray = kid.kids.asMutable ? kid.kids.asMutable() : kid.kids || [];
                            grandKids = map(grandKidArray, (grandKid, j) =>
                                <li
                                    key={`sitenav-grandkid-link-${grandKid.title}`}
                                    className={'grandkid'}
                                    data-index={j}
                                    onClick={this.clickKidLink}>
                                    <a
                                        className={`text-color-hover ${this.props.activeChild !== null &&
                                            this.props.activeChild === i ? 'text-color-active' : 'text-color-nonactive'}`}
                                        href={grandKid.href || null}
                                        target={grandKid.target}>
                                        <span>{grandKid.title}</span>
                                    </a>
                                </li>
                            );
                        }

                        return (
                            <li
                                key={`sitenav-kid-link-${kid.title}`}
                                className={`kid ${this.props.activeChild !== null &&
                                    this.props.activeChild === i ? 'active' : ''} ${grandKids && grandKids.length ? 'spread-arrow text-color-border-after' : ''}`}
                                onMouseEnter={this.kidHover}
                                onMouseLeave={this.kidMouseLeave}
                                data-gkl={grandKids && grandKids.length ? grandKids.length : 0}
                                data-index={i}
                                onClick={this.clickKidLink}>

                                <a
                                    className={`text-color-hover ${this.props.activeChild !== null &&
                                        this.props.activeChild === i ? 'text-color-active' : 'text-color-nonactive'}`}
                                    href={kid.href || '#'}
                                    target={kid.target}>
                                    <span>{kid.title}</span>
                                </a>
                                <ul className={grandKids && grandKids.length ? 'grand-kids' : 'hidden'}>{grandKids}</ul>
                            </li>
                        );
                    })
                }
            </ul>
        );
    }
}

SiteNavKids.propTypes = {
    kids: React.PropTypes.array,
    isMobile: React.PropTypes.bool,
    isTablet: React.PropTypes.bool,
    parentLink: React.PropTypes.object,
    onBack: React.PropTypes.func,
    active: React.PropTypes.bool,
    activeChild: React.PropTypes.number,
    onClick: React.PropTypes.func,
    parentIndex: React.PropTypes.number
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/siteNav/SiteNavKids.js
 **/